import type { OMPSearchString } from "@src/api/types/OmpApiTypes";
import type { ApiKoType } from "@src/api/konstrObjs/koTypes";

/** Класс номенклатуры на складе. */
export enum ApiStockObjTypes {
    /** Конструкторские объекты */
    Ko = 0,
    /** Материалы */
    Material = 1,
    /** Другие ТМЦ */
    Other = 2,
    /** Тара */
    Tare = 3,
    /** Конструкторская/контрактная спецификация */
    KSpec = 4,
}

/** ТМЦ (товарно-материальная ценность) — контракт OMP. */
export interface ApiStockObj {
    Code: number;
    /** Код в базовой таблице (КЭ, материал, прочее) */
    BaseCode: number;
    BaseType: ApiStockObjTypes;
    /** Код типа КО; актуален при {@link ApiStockObjTypes.Ko} */
    KoType: number;
    Sign: string;
    Name: string;
    NomNum: string;
    MeasCode: number;
    Notice: string;
    Description: string;
}

/** Фильтр `stockobjs.loadByFilter`. */
export interface ApiStockObjFilter {
    Codes?: number[];
    Sign?: OMPSearchString;
    Name?: OMPSearchString;
    NomNum?: OMPSearchString;
    Description?: OMPSearchString;
}

/** Связи для {@link stockObjsServices.loadByFilter}. */
export interface StockObjExtends {
    KoTypeObj?: ApiKoType;
}

/** ТМЦ с опциональной расшифровкой типа КО. */
export type StockObj = ApiStockObj & Partial<StockObjExtends>;
